import { render } from "./EulaText.vue?vue&type=template&id=36c96b5c"
import script from "./EulaText.vue?vue&type=script&lang=js"
export * from "./EulaText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__